import React from "react";
import { map } from "lodash";
import { Form } from "react-bootstrap";

import { states } from "statics/countriesAndStates";

interface StateSelectProps {
  value?: string;
  handleBlur?: React.FocusEventHandler<HTMLSelectElement>;
  handleChange?: React.ChangeEventHandler<HTMLSelectElement>;
  touched: { state?: boolean };
  errors: { state?: string };
  customPlaceholder?: string;
  name?: string;
}

const StateSelect = ({
  value,
  handleBlur,
  handleChange,
  touched,
  errors,
  customPlaceholder,
  name = "state",
}: StateSelectProps) => {
  return (
    <Form.Select
      name={name}
      value={value}
      onBlur={handleBlur}
      onChange={handleChange}
      isInvalid={touched.state && !!errors.state}
      isValid={touched.state && !errors.state}
    >
      <option value="" disabled>
        {customPlaceholder || "Select State"}
      </option>
      {map(states, (stateLabel, stateAbbrv) => (
        <option key={stateLabel} value={stateAbbrv}>
          {stateLabel}
        </option>
      ))}
    </Form.Select>
  );
};

export default StateSelect;
